import React, { useEffect, useState } from "react";
import { Tooltip, Button, Form } from "antd";
import { Styled } from "../../Pages/pageStyled.js";
import Iconmoon from "../IconsFiles/icon.js";
import moment from "moment";
import {
  lengthUnit,
  weightUnit,
} from "../../Utils/Constant/MeasurementUnitList.jsx";
import { EditSetsContainer } from "../../Pages/styledElements.js";
import { useForm } from "antd/lib/form/Form";
import Input from "rc-input";
import {
  cancelSheetWeight,
  rearrangeCuttingPatterns,
} from "../../Services/productionPlanningServices.js";
const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);
const SheetRow = ({
  row,
  index,
  isValidState,
  cylinderData,
  isSingleCylinder = false,
  height,
  width,
  jobId,
  acceptedSolution,
  reFetchToggle,
  cylinderViewData
}) => {
  const [form] = useForm();
  const [isLoading, setIsloading] = useState(false);
  const [inputText, setInputText] = useState(row?.weight?.toFixed(3));
  const [isEditEnabled, setIsEditEnabled] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const [dragId, setDragId] = useState({});
  const [columnsArray, setColumnsArray] = useState([]);
  const rewinderString = `Rewinder: ${cylinderData[index]?.rewinder_name}(${cylinderData[index]?.rewinder_code})`;
  const sheetColor = {
    light: "#fbe0de",
    "light-highlighted": "#fbe0de",
    dark: "#fb967f",
    "dark-highlighted": "#fb967f",
    "stock-light": "#fdf0ef",
    "stock-light-highlighted": "#fdf0ef",
    darkgray: "#E1DFDD",
  };

  useEffect(() => {
    // console.log("cols", columnsArray);
  }, [columnsArray]);
  const validateInput = (newValue) => {
    const validInputPattern = /^(\d*\.)?\d+$/;
    if (!validInputPattern.test(newValue)) {
      setErrorMsg("Enter a positive integer");
      return;
    }
    if (newValue > row?.weight) {
      setErrorMsg("New weight can't be greater");
      return;
    }
    setInputText(newValue);
    setErrorMsg();
  };
  const handleInputChange = (e) => {
    let newValue = e.target.value.trim();
    validateInput(newValue);
  };
  const handleEditSetsToggle = (isCancelled, row, index) => {
    setIsEditEnabled(!isEditEnabled);
    setDragId({});
    setErrorMsg();
    setInputText(parseFloat(row?.weight?.toFixed(3)));
    isCancelled && setColumnsArray(row.columns);
    // setInputText(row?.weight?.toFixed(3));
    setErrorMsg();
    form.setFieldsValue({"cancel-set-input": row?.weight?.toFixed(3)});
  };
  const handleSave = () => {
    if (!inputText) {
      setErrorMsg("Please enter an integer");
      return;
    }
    const cancelledWeight = row?.weight - parseFloat(inputText);
    const request = {
      jobcard_id: jobId,
      cutting_pattern_index: index,
      cancelled_weight: cancelledWeight,
      units: {
        cancelled_weight: cylinderData[index]?.units?.weight,
      },
    };
    const newIndexArray = columnsArray.map((col) => {
      if (col.originalIndex === row.columns.length) return "trimloss";
      return col.originalIndex;
    });
    let isSameAsOriginal = true;
    newIndexArray.map((col, idx) => {
      if (col !== idx && col !== "trimloss") isSameAsOriginal = false;
    });
    const cuttingRequest = {
      jc_id: jobId,
      accepted_solution: `solution_${acceptedSolution}`,
      cutting_partitions: isSameAsOriginal ? [] : newIndexArray,
      pattern_index: index,
    };
    setIsloading(true);
    cancelSheetWeight(request)
      .then((res) => {
        setErrorMsg();
        setInputText();
        setIsEditEnabled(false);

        rearrangeCuttingPatterns(cuttingRequest)
          .then((res) => {
            if (reFetchToggle) reFetchToggle();
            // console.log(121212121, reFetchToggle);
          })
          .catch((err) => {
            setErrorMsg(err.response.data.msg);
          });
      })
      .catch((err) => {
        setErrorMsg(err.response.data.msg);
      })
      .finally(() => setIsloading(false));
  };
  const handleDrag = (ev, index) => {
    if (!isEditEnabled) return;

    return setDragId(JSON.parse(ev.currentTarget.id));
  };

  const handleDrop = (ev, index) => {
    // console.log(ev);
    if (!isEditEnabled) return;
    const target = JSON.parse(ev.currentTarget.id);

    const dragCylinderIndex = columnsArray.findIndex(
      (col) =>
        col.originalIndex == dragId.originalIndex &&
        dragId.combinationNumber === col.combinationNumber
    );
    const dropCylinderIndex = columnsArray.findIndex(
      (col) =>
        col.originalIndex == target.originalIndex &&
        target.combinationNumber === col.combinationNumber
    );
    // console.log(dropCylinderIndex, dragCylinderIndex, target, dragId);
    if (
      dragCylinderIndex === -1 ||
      dropCylinderIndex === -1 ||
      dragId.combinationNumber != target.combinationNumber
    )
      return;
    let newCylinderOrders = [...columnsArray];
    const draggedCylinder = newCylinderOrders.splice(dragCylinderIndex, 1)[0]; // Remove the dragged cylinder
    newCylinderOrders.splice(dropCylinderIndex, 0, draggedCylinder); // Insert the dragged cylinder at the drop position
    // newCylinderOrders.map((order, index) => {
    //   order.left = -23 * index;
    //   return order;
    // });
    setColumnsArray(newCylinderOrders);
    setDragId({});
  };

  useEffect(() => {
    setColumnsArray(row?.columns);
  }, [row]);

  return (
    <div key={index} style={{ width: "100%" }}>
      {cylinderData && !isSingleCylinder && (
        <p
          style={{
            paddingRight: "20px",
            color: "black",
            paddingTop: index > 0 && "20px",
            display: "flex",
            justifyContent: "space-between",
            color: "var(--para-text)",
            fontSize: "12px !important",
            fontFamily: "var(--sf-pro-text) !important",
          }}
        >
          <span style={{ fontFamily: "var(--sf-pro-text) !important" }}>
            Reel Size: {cylinderData[index]?.reel_size}{" "}
            {cylinderData[index]?.units?.reel_size
              ? lengthUnit[cylinderData[index]?.units?.reel_size]?.displayName
              : "CM"}
          </span>
          <span style={{ fontFamily: "var(--sf-pro-text) !important" }}>
            Reels: {cylinderData[index]?.no_of_reels}
            {/* -
            cylinderData[index]?.cancelled_no_of_reels} */}
          </span>
          <span style={{ fontFamily: "var(--sf-pro-text) !important" }}>
            Reel Dia: {cylinderData[index]?.reel_dia}{" "}
            {cylinderData[index]?.units?.reel_od
              ? lengthUnit[cylinderData[index]?.units?.reel_od]?.displayName
              : "cm"}
            /{cylinderData[index]?.core_dia}{" "}
            {cylinderData[index]?.units?.core_id
              ? lengthUnit[cylinderData[index]?.units?.core_id]?.displayName
              : "cm"}
          </span>
          {(cylinderData[index]?.combination_position?.length >= 3 &&
            rewinderString.length > 20) ||
          rewinderString.length > 35 ? (
            <Tooltip
              title={
                <>
                  {cylinderData[index]?.rewinder_name}(
                  {cylinderData[index]?.rewinder_code}){" "}
                </>
              }
            >
              <span
                style={{
                  fontFamily: "var(--sf-pro-text) !important",
                  // display: "inline-block",
                  // overflow: "hidden",
                  // textOverflow: "ellipsis",
                  // whiteSpace: "nowrap",
                }}
              >
                {rewinderString.slice(0, 20)}
                {"..."}
              </span>
            </Tooltip>
          ) : (
            <span style={{ fontFamily: "var(--sf-pro-text) !important" }}>
              Rewinder: {cylinderData[index]?.rewinder_name}(
              {cylinderData[index]?.rewinder_code}){" "}
            </span>
          )}
          {/* < style={{fontFamily: 'var(--sf-pro-text) !important'}}span>Rewinder Name: </> */}
          {cylinderData[index]?.combination_position?.length > 3 ? (
            <Tooltip
              title={cylinderData[index]?.combination_position
                ?.map((com) => com.combination)
                ?.join(",")}
            >
              <span style={{ fontFamily: "var(--sf-pro-text) !important" }}>
                Com. No.:{" "}
                {cylinderData[index]?.combination_position
                  ?.slice(0, 3)
                  ?.map((com) => com.combination)
                  ?.join(",")}
                ...
              </span>
            </Tooltip>
          ) : (
            <span style={{ fontFamily: "var(--sf-pro-text) !important" }}>
              Com. No.:{" "}
              {cylinderData[index]?.combination_position
                ?.slice(0, 3)
                ?.map((com) => com.combination)
                ?.join(",")}
              {cylinderData[index]?.combination_position?.length > 3
                ? "..."
                : ""}
            </span>
          )}
        </p>
      )}
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <div
          className="sheet-row"
          style={{
            width: `calc(${width}px)`,
            // justifyContent:"end"
            display: "flex",
            justifyContent: isSingleCylinder ? "space-evenly" : "flex-start",
          }}
        >
          {columnsArray?.map((column, columnIndex) =>
            column.item_type !== "trimloss" ? (
              <Tooltip
                key={columnIndex}
                title={`${
                  cylinderViewData !== "production" 
                    ? `${column.item_type === "order" ? "Order No.: " : "Stock No.: "} ${column.id}`
                    : ""
                }
                Size:${column.size} ${
                  (row.row_meta.units &&
                    " " + lengthUnit[row.row_meta.units.size].displayName) ||
                  ""
                } x ${
                  (isSingleCylinder
                    ? column.length_data
                    : row.row_meta.length) +
                    (row.row_meta.units &&
                      " " +
                        lengthUnit[row.row_meta.units.length].displayName) || ""
                } \nGrain: ${
                  column.grain?.toLowerCase() === "short" ? "Short" : "Long"
                } \nWeight: ${(
                  column.weight -
                  (column.cancelled_weight ? column.cancelled_weight : 0)
                )?.toFixed(3)} ${
                  row?.row_meta?.units
                    ? capitalize(
                        weightUnit[row.row_meta?.units?.weight].displayName,
                      )
                    : ""
                } \nPriority: ${column.priority === 1 ? "Yes" : "No"}`}
              >
                <div
                  className={
                    column?.color == "darkgray"
                      ? "sheet-gray-col-multistage"
                      : column.color === "dark"
                        ? "sheet-col-multistage-dark"
                        : "sheet-col-multistage"
                  }
                  style={{
                    width: `${column.percentWidth}%`,
                    height,
                    minHeight: "70px",
                    backgroundColor: column?.color
                      ? sheetColor[column?.color]
                      : sheetColor["light"],
                    boxShadow: isEditEnabled && "0 3px 12px rgb(0 0 0 / 0.2)",
                  }}
                  draggable={isEditEnabled}
                  onDragOver={(ev) => ev.preventDefault()}
                  onDragStart={handleDrag}
                  onDrop={handleDrop}
                  id={JSON.stringify({
                    originalIndex: column.originalIndex,
                    combinationNumber: index,
                  })}
                >
                  {(column.percentWidth / 100) * width > 30 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                        flexDirection: "column",
                      }}
                    >
                      {isEditEnabled && (
                        <svg
                          style={{
                            // position: "absolute",
                            top: "35%",
                            // alignSelf: "center",
                            width: "15px",
                            opacity: "0.7",
                            // left: "50%",
                            // transform: "translate(-100%, -50%)",
                          }}
                          viewBox="64 64 896 896"
                          focusable="false"
                          data-icon="holder"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"></path>
                        </svg>
                      )}
                      <span style={{ fontSize: "12px", textAlign: "center" }}>
                        {column.size}{" "}
                        {(row.row_meta.units &&
                          " " +
                            lengthUnit[row.row_meta.units.size].displayName) ||
                          ""}
                      </span>
                    </div>
                  ) : (
                    <span>.</span>
                  )}
                </div>
              </Tooltip>
            ) : (
              <Tooltip
                key={columnIndex}
                title={`Type: Trim Loss\nTrim Loss: ${row?.row_meta?.trim_loss} ${row?.row_meta?.units?.trim_loss}`}
              >
                <div
                  className="sheet-col"
                  style={{
                    width: `${row.row_meta.percentTrimLossWidth}%`,
                    height,
                    minHeight: "70px",
                    backgroundColor: "white",
                    border: "none",
                  }}
                  draggable={isEditEnabled}
                  onDragOver={(ev) => ev.preventDefault()}
                  onDragStart={handleDrag}
                  onDrop={handleDrop}
                  id={JSON.stringify({
                    originalIndex: column.originalIndex,
                    combinationNumber: index,
                  })}
                ></div>
              </Tooltip>
            ),
          )}{" "}
        </div>
        {!isSingleCylinder && (
          <div
            style={{
              width: "190px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingLeft: "10px",
            }}
          >
            <span
              style={{
                fontSize: "12px",
                lineHeight: "16px",
                width: "190px",
              }}
            >
              <p style={{ lineHeight: "16px" }}>
                Chop:{" "}
                {row.row_meta.length +
                  (row.row_meta.units
                    ? " " + lengthUnit[row.row_meta.units.length].displayName
                    : "")}
              </p>
              <p style={{ lineHeight: "16px" }}>
                Del: {moment(row.row_meta.deadline).format("DD MMM YYYY")}
              </p>
              <p
                style={{
                  lineHeight: "16px",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                Weight:{" "}
                {!isEditEnabled ? (
                  row.row_meta.totalWeight?.toFixed(3) +
                  (row.row_meta.units
                    ? " " +
                      capitalize(
                        weightUnit[row.row_meta.units.weight].displayName,
                      )
                    : "")
                ) : (
                  <EditSetsContainer style={{ width: "30%" }}>
                    <Form form={form}>
                      <Form.Item
                        name="cancel-set-input"
                        initialValue={inputText}
                        style={{
                          margin: "0px",
                          padding: "0px",
                          minHeight: "0px",
                          //   width: "50px",
                          border: "1px solid #d9d9d9 !important",
                        }}
                      >
                        <Input
                          className="input_sheet"
                          size="small"
                          onChange={handleInputChange}
                          disabled={isLoading}
                          style={{ border: "1px solid #d9d9d9 !important" }}
                        />
                      </Form.Item>
                    </Form>
                  </EditSetsContainer>
                )}
                {isValidState && (
                  <EditSetsContainer>
                    {!isEditEnabled ? (
                      <div className="edit-container">
                        {row?.weight && row?.row_meta?.allowRearranging ? (
                          <Styled>
                            <Tooltip
                              placement="bottom"
                              title={"Edit weight"}
                              className="edit-tooltip"
                            >
                              <Button
                                className="btn"
                                onClick={() =>
                                  handleEditSetsToggle(false, row, index)
                                }
                              >
                                <Iconmoon
                                  icon="edit"
                                  size={12}
                                  style={{
                                    // opacity: row?.weight ? 0.8 : 0,
                                    transform: "translateX(-5px)",
                                  }}
                                  color="#8E8583"
                                />
                              </Button>
                            </Tooltip>
                          </Styled>
                        ) : null}
                        <Styled>
                          <Tooltip
                            placement="bottom"
                            title={`Total Weight: ${
                              row.row_meta?.total_weight
                            } ${capitalize(
                              row.row_meta?.units?.total_weight,
                            )}\nCancelled Weight: ${
                              row.row_meta?.cancelled_weight
                            } ${capitalize(row.row_meta?.units?.total_weight)}`}
                            className="edit-tooltip"
                          >
                            <Button
                              className="btn"
                              // onClick={() => handleEditSetsToggle()}
                              style={{
                                width: row?.weight ? "" : "100%",
                                marginLeft: row?.weight ? "" : "10px",
                              }}
                            >
                              <Iconmoon
                                icon="info_new"
                                size={15}
                                color="#8E8583"
                                style={{
                                  // opacity: 0.7,
                                  marginTop: "2px",
                                  float: "right",
                                }}
                              />
                            </Button>
                          </Tooltip>
                        </Styled>
                      </div>
                    ) : (
                      <div className="edit-container" style={{ width: "40%" }}>
                        {!errorMsg && (
                          <Tooltip placement="bottom" title="Save changes">
                            <Button
                              className="btn"
                              style={{
                                marginTop: "2px",
                                transform: isLoading && "translateY(-4px)",
                                background: "transparent !important",
                                cursor: "pointer",
                              }}
                              onClick={() => handleSave()}
                              loading={isLoading}
                            >
                              {!isLoading && (
                                <Iconmoon
                                  icon="check"
                                  size={14}
                                  color="green"
                                />
                              )}
                            </Button>
                          </Tooltip>
                        )}
                        {!isLoading && (
                          <Tooltip placement="bottom" title="Discard changes">
                            <Button
                              className="btn"
                              style={{ marginTop: "2px" }}
                              onClick={() =>
                                handleEditSetsToggle(true, row, index)
                              }
                              loading={isLoading}
                            >
                              <Iconmoon icon="cancel" size={14} color="red" />
                            </Button>
                          </Tooltip>
                        )}
                      </div>
                    )}
                  </EditSetsContainer>
                )}
              </p>
              <p
                // className="error"
                style={{
                  color: "red",
                  fontSize: "9px",
                  margin: "0px",
                  padding: "0px",
                  transform: "translateY(-7px)",
                  lineHeight: 1,
                  position: "absolute",
                }}
              >
                {errorMsg}
              </p>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SheetRow;
